import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, hexToRgbaWithAlpha } from '../../theme';
import { absolute } from '../../styles/mixins';

export const useGaugeStyles = createStyles(() => ({
  container: {
    position: 'relative',
  },
  svg: {
    display: 'block',
  },
  shadow: {
    ...absolute(0),
    borderRadius: '50%',
    boxShadow: `0 0 35px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY6, 0.45)}`,
  },
  valueText: {
    ...absolute(0, 'initial'),
    transform: 'translateY(-50%)',
    textAlign: 'center',
    zIndex: 2,
    fontSize: '12%',
    fontWeight: 'bold',
    letterSpacing: '-1px',
    color: ThemeColors.COLOR_GREY_DARK1,
    lineHeight: 1,

    '.help-text': {
      fontSize: '62.5%',
      letterSpacing: 0,
    },
  },
  axisLabel: {
    position: 'absolute',
    color: ThemeColors.COLOR_GREY2,
    fontSize: '6.75%',
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
    lineHeight: 1,
  },
}));
